import { format, parseISO } from 'date-fns'
import { useCallback } from 'react'
import { useDateLocale } from './useDateLocale'

export const useFormat = () => {
  const locale = useDateLocale()
  return useCallback(
    (date: any, formatStr = 'PPPPpp', options?: any) => {
      if (!date) return null
      if (typeof date === 'string') date = parseISO(date)
      return format(date, formatStr, {
        locale,
        ...options,
      })
    },
    [locale]
  ); // as typeof format
}
